import React from 'react';
import Icon from '../../../../../../../helper/Icon';

const renderVariantItems = (onSelect, type, family, variants) => variants.map((variant, i) => (
  <div
    className="variantItemContainer blocks-group__link"
    key={i}
    onClick={onSelect(type, family, variant.name)}
  >
    <div className="blocks-group__label">{variant.label}</div>
    <div className="variantImage">
      <img
        src={variant.imageUrl || 'https://dummyimage.com/270x180/fff/fff&text=_____'}
        alt={variant.label}
      />
    </div>
  </div>
));

const BlockTypeItem = ({ index, open, type, onButtonClick, onSelect }) => (
  <div className="BlockTypeItem">
    <div className="typeButton" onClick={onButtonClick}>
      {!open ? (
        <Icon icon="add" fill="rgba(14, 14, 14, 0.6)" size="21px" />
      ) : (
        <Icon icon="remove" fill="rgba(14, 14, 14, 0.7)" size="21px" />
      )}
      <span className="typeLabel">{type.label}</span>
    </div>
    <div className="variantItemsContainer">
      {open && renderVariantItems(onSelect, type.type, type.family, type.variants)}
    </div>
  </div>
);

export default BlockTypeItem;
